import { cn } from "@heroui/react";
import { JobPositionType } from "@sr-partner-portal/common";
import {
    IconEyeglass,
    IconEyeglassOff,
    IconSchool,
    IconSchoolOff,
    IconUser,
    IconUserOff,
} from "@tabler/icons-react";

export const getJobPositionTypeIcon = ({
    type,
    isArchived,
}: {
    type: keyof typeof JobPositionType | string;
    className?: string;
    isArchived?: boolean;
}) => {
    if (type === JobPositionType.TRAINEE) {
        return isArchived ? IconSchoolOff : IconSchool;
    }

    if (type === JobPositionType.EMPLOYEE) {
        return isArchived ? IconUserOff : IconUser;
    }

    if (type === JobPositionType.DUAL_STUDENT) {
        return isArchived ? IconEyeglassOff : IconEyeglass;
    }

    return null;
};

export const JobPositionTypeIcon = ({
    type,
    size = 20,
    className,
    isArchived,
}: {
    type: keyof typeof JobPositionType | string;
    size?: number;
    className?: string;
    isArchived?: boolean;
}) => {
    const Icon = getJobPositionTypeIcon({ type, isArchived });

    if (!Icon) {
        return null;
    }

    return (
        <Icon
            className={cn("inline shrink-0 text-default-500", className)}
            stroke={1.5}
            size={size}
        />
    );
};
